import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=054e5ebd&"
import script from "./EditProject.vue?vue&type=script&lang=ts&"
export * from "./EditProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports